import React, { useEffect, useState } from "react";
import { countDistributions } from "../../services/distributionsServices";
import { FiGrid, FiRefreshCw } from "react-icons/fi";

const formatNumber = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(n || 0);

export default function DistributionsStatCard() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [updatedAt, setUpdatedAt] = useState(null);

  const load = async () => {
    try {
      setErr("");
      setLoading(true);
      const res = await countDistributions(); // <- renvoie un number
      setCount(Number(res) || 0);
      setUpdatedAt(new Date());
    } catch (e) {
      console.error(e);
      setErr("Erreur lors du chargement des distributions.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section className="w-full font-montserrat">
      <div className="flex items-center justify-between mb-2">
        {/* <h3 className="text-sm uppercase font-light">Distributions</h3> */}
        <div className="flex items-center gap-2 text-xs opacity-80">
          <button
            type="button"
            onClick={load}
            className="btn btn-xs btn-outline"
            title="Recharger"
            aria-label="Recharger"
          >
            <FiRefreshCw />
          </button>
        </div>
      </div>

      {loading ? (
        <div className="rounded-2xl p-5 h-28 bg-gray-100 dark:bg-gray-800 animate-pulse" />
      ) : err ? (
        <div className="rounded-2xl p-4 bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-200">
          {err}
        </div>
      ) : (
        <div className="rounded-2xl p-5 shadow-lg text-white bg-gradient-to-r from-blue-600 via-violet-600 to-rose-600">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-sm opacity-90">Total distributions</span>
              <span className="text-4xl font-bold leading-tight">
                {formatNumber(count)}
              </span>
            </div>
            <div className="p-3 rounded-xl bg-white/20">
              <FiGrid className="text-white" size={28} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
